import { useEffect, useState } from "react";

export function useJustUpdated(key: string | number | null, durationMs = 1500): boolean {
  const [prevKey, setPrevKey] = useState<string | number | null | undefined>(undefined);
  const [justUpdated, setJustUpdated] = useState(false);

  if (key !== prevKey) {
    const isInitialCapture = prevKey === undefined;
    setPrevKey(key);
    if (!isInitialCapture && key !== null) {
      setJustUpdated(true);
    }
  }

  useEffect(() => {
    if (!justUpdated) return;
    const timer = setTimeout(() => setJustUpdated(false), durationMs);
    return () => clearTimeout(timer);
  }, [justUpdated, prevKey, durationMs]);

  return justUpdated;
}
